export type AndroidBackAction = "close-overlay" | "go-back" | "confirm-exit";

const OPEN_OVERLAY =
  '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]';

export function decideAndroidBack(input: {
  overlayOpen: boolean;
  canGoBack: boolean;
}): AndroidBackAction {
  if (input.overlayOpen) return "close-overlay";
  if (input.canGoBack) return "go-back";
  return "confirm-exit";
}

export function overlayIsOpen(): boolean {
  if (typeof document === "undefined") return false;
  return document.querySelector(OPEN_OVERLAY) != null;
}

/** Radix dialogs close on Escape. Hardware Back should do the same, not pop history. */
export function dispatchOverlayDismiss(): void {
  document.dispatchEvent(
    new KeyboardEvent("keydown", {
      key: "Escape",
      code: "Escape",
      bubbles: true,
      cancelable: true,
    }),
  );
}
